import Vue from 'vue'
import Vuex from 'vuex'
import * as _ from 'lodash'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        apps: []
    },
    getters: {
        appDetail: (state) => (appId) => {
            let app = {}
            for (const appItem of state.apps) {
                if (appId === appItem.id) {
                    app = appItem
                    break
                }
            }
            return app
        }
    },
    mutations: {
        saveApps(state, apps) {
            if (!_.isArray(apps)) {
                apps = []
            }
            state.apps = apps
        }
    }
})

export default store